/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Arch_Universal_CliInputs */

const en_fc_dl_arch_universal_cli = /** @type {(inputs: Fc_Dl_Arch_Universal_CliInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universal`)
};

/**
* | output |
* | --- |
* | "Universal" |
*
* @param {Fc_Dl_Arch_Universal_CliInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_arch_universal_cli = /** @type {((inputs?: Fc_Dl_Arch_Universal_CliInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Arch_Universal_CliInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_arch_universal_cli(inputs)
});
export { fc_dl_arch_universal_cli as "fc.dl.arch.universal_cli" }